import type { PortfolioCategoryId } from "web_myplann/Portfolio/Types/portfolioCategory";

export const normalizePortfolioCategories = (
	categories: PortfolioCategoryId[],
	available: PortfolioCategoryId[],
): PortfolioCategoryId[] => {
	if (available.length === 0) {
		return categories;
	}

	const shown = categories.filter((id) => available.includes(id));

	return shown.length === available.length ? [] : shown;
};
